CF.util = {
	/**
	 * Execute when idle
	 *
	 * @param {(Array|Function)} fn
	 * @param {Object} [context]
	 */
	idle: function(fn, context) {
		fn = $.toArray(fn);

		if ('requestIdleCallback' in $._win) {
			fn.forEach(function(el) {
				requestIdleCallback(function() {
					el.apply(context);
				});
			});

			return;
		}

		fn.forEach(function(el) {
			requestAnimationFrame(function() {
				el.apply(context);
			});
		});
	}
};